import { findMessage } from '@bimser/components';
import { MessageBox, MessageBoxButton, MessageBoxButtons } from '..';
import { IWindowUpdatePayload } from '../entities/IUpdatePayload';

interface ILSManagerProps {
	windowId: string;
	keyPrefix?: string;
	startDataHash?: string;
	onUpdateWindow?: (payload: IWindowUpdatePayload) => void;
}

export default class LocalStorageManager {
	id: string;
	windowId: string;
	keyPrefix: string;
	onUpdateWindow?: (updatePayload: IWindowUpdatePayload) => void;

	constructor(args: ILSManagerProps) {
		const { keyPrefix, startDataHash, windowId, onUpdateWindow } = args;

		this.id = [keyPrefix, startDataHash, windowId].filter(i => i).join('/');
		this.windowId = windowId;
		this.keyPrefix = keyPrefix;
		this.onUpdateWindow = onUpdateWindow;
	}

	setData(saveData: any) {
		if (typeof saveData != 'string') {
			saveData = JSON.stringify(saveData);
		}
		localStorage.setItem(this.id, saveData);
	}

	private doNotUseLocalStroge(resolve: (value: any) => void) {
		this.cleanLocalData();
		resolve(null);
		this.updateWindow({ showLoading: false });
	}

	private updateWindow(updatePayload: IWindowUpdatePayload) {
		this.onUpdateWindow?.({ ...updatePayload, id: this.windowId });
	}

	deleteContent(deleteKeys: string[]) {
		return (
			<div>
				<div>
					<b>{findMessage.get('100022')}:</b> {findMessage.get('102868')}
				</div>
				<div>
					<b>{findMessage.get('102867')}:</b>
				</div>
				{deleteKeys
					?.map(key => key.split('/'))
					.map(keyArr => {
						if (keyArr[2]) {
							return <div key={keyArr.join('/')}>{`Id: ${keyArr[2]}`}</div>;
						}

						return null;
					})}
			</div>
		);
	}

	garbageCollector() {
		const deleteKeys = Object.keys(localStorage).filter(key => key.startsWith(this.keyPrefix));

		MessageBox.warning({
			buttons: MessageBoxButtons.ClearCancel,
			content: this.deleteContent(deleteKeys),
			title: findMessage.get('102869'),
			width: '800px'
		}).then(result => {
			if (result.button.id === MessageBoxButton.Clear) {
				for (const item of deleteKeys) {
					localStorage.removeItem(item);
				}
			} else {
				this.updateWindow({ showLoading: false, isModified: false });
			}
		});
	}

	getData(): Promise<any> {
		return new Promise<any>(resolve => {
			this.updateWindow({ showLoading: true });
			const localData = localStorage.getItem(this.id);
			if (localData) {
				MessageBox.confirm({
					buttons: MessageBoxButtons.YesNo,
					content: findMessage.get('101833'),
					title: findMessage.get('101832'),
					width: '600px'
				}).then(result => {
					if (result.button.id === MessageBoxButton.Yes) {
						resolve(JSON.parse(localData));
						this.updateWindow({ showLoading: false, isModified: true });
					} else {
						this.doNotUseLocalStroge(resolve);
					}
				});
			} else {
				resolve(null);
				this.updateWindow({ showLoading: false });
				this.cleanOutOfDateVersions();
			}
		});
	}

	cleanOutOfDateVersions() {
		const regexPattern = new RegExp(`${this.keyPrefix}/\\w+/${this.windowId}`);
		const deleteKeys = Object.keys(localStorage).filter(str => regexPattern.test(str));

		for (const item of deleteKeys) {
			localStorage.removeItem(item);
		}
	}

	cleanLocalData() {
		localStorage.removeItem(this.id);
	}
}
